<div class="abstract-card" [ngStyle]="{ border: '1px solid ' + (backgroundColor || defaultBackground) }">
  <div class="box-media">
    <cx-media [container]="CMSAbstractGridEntry.image"></cx-media>
  </div>

  <section class="p-lr-12 abstract-card__container d-flex flex-column" [ngStyle]="{ background: backgroundColor || defaultBackground }">
    <h3 class="p-t-12 text-primary">
      {{ CMSAbstractGridEntry.name }}
    </h3>

    <div [innerHTML]="CMSAbstractGridEntry.content" class="abstract-card__content m-t-12"></div>

    <div class="abstract-card__footer mt-auto">
      <cx-generic-link
        [url]="CMSAbstractGridEntry.url?.url!"
        [ariaLabel]="CMSAbstractGridEntry.url?.linkName"
        [attr.title]="CMSAbstractGridEntry.url?.linkName"
        [class]="'btn btn-outline-primary w-100 btn-action'"
      >
        {{ CMSAbstractGridEntry.url?.linkName }}
      </cx-generic-link>
    </div>
  </section>
</div>
